import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);

const formatDate = (dateString) => {
    const parsedDate = dayjs(dateString);

    if (!parsedDate.isValid()) {
        return "Fecha inválida";
    }

    return parsedDate.local().format("YYYY-MM-DD HH:mm:ss");
};


export default formatDate;